var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:25px;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.52,
    y: 61.63,
    width: 632.89,
    height: 896.52,
    rx: 25.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 185.52,
    y1: 544.73,
    x2: 365.52,
    y2: 544.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 185.52,
    y1: 412.56,
    x2: 430.32,
    y2: 412.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 185.52,
    y1: 280.39,
    x2: 615.93,
    y2: 280.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 473.76,
    y: 601.36,
    width: 481.2,
    height: 388.5,
    rx: 29.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 650.63,
    cy: 638.63,
    r: 71.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 771.49,
    cy: 658.9,
    r: 71.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 453.24,
    y: 636.1,
    width: 481.2,
    height: 382.27,
    rx: 29.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 811.54,
    y: 765.64,
    width: 181.93,
    height: 123.19,
    rx: 25.23
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/ICON_Wallet.f6731d1d1e47bae678ce65692783eef8.svg";
export { ForwardRef as ReactComponent };